<template>
  <section class="section hub-resources-carousel" v-if="results && computedPayload.visible">
    <div class="container mx-auto flex flex-wrap items-center px-4">

      <div class="section-title__wrapper">
        <h3 class="section-title">{{ computedPayload['section-title'] }}</h3>
      </div>
      <div class="section-btn__wrapper">
        <a class="btn bg-blue-light text-white uppercase" :href="`/resources?q=resource-type=${resource_type}`">View all</a>
      </div>

      <div class="resources__cards">
        <Carsousel type="Resource" :payload="results" :settings="settings"></Carsousel>
      </div>

    </div>
  </section>
</template>

<script>
import algoliasearch from 'algoliasearch';
import Carsousel from '../carousel-layouts/Carousel.vue';

export default {
  name: 'HubResourcesCarousel',

  components: {
    Carsousel
  },

  props: {
    resource_type: {
      type: String
    },
    payload: {
      type: [Object,String]
    }
  },

  data() {
    return {
      client: false,
      index: false,
      index_name: (this.$config.test_env) ? 'resources-dev' : 'resources-live',
      searchObject: {
        hitsPerPage: 20,
        facets: ['slug'],
        facetFilters: []
      },
      results: false,
    }
  },

  created() {
    this.client = algoliasearch(this.$config.algolia.app_id, this.$config.algolia.app_key);
    this.index = this.client.initIndex(this.index_name);

    console.log('HUBPAGE:RESOURCECAROUSEL:', this.computedPayload);
    // Set hitsPerPage to length of this.computedPayload.slugs array.
    // Loop through this.computedPayload.slugs and prefixing them with 'slugs:', then add them to facetFilters.
    this.searchObject.hitsPerPage = this.computedPayload.slugs.length;
    this.searchObject.facetFilters.push(this.computedPayload.slugs.map(el => `slug:${el}`));

    this.index
      .search('', this.searchObject)
      .then((results) => {
        // console.log("Hub resource carousel search raw results:", results);
        if (results.nbHits > 0) {
          this.results = results.hits;
        } else {
          this.results = false;
        }
      });
  },

  computed: {
    computedPayload() {
      return typeof this.payload === 'string' ? JSON.parse(this.payload) : this.payload;
    },
    settings() {
      return {
        width: '100%',
        gap: '1rem',
        pagination: false,
        arrows: false,
        perPage: 5,
        breakpoints: {
          480: {
            perPage: 1,
            drag: this.results.length >= 1
          },
          768: {
            perPage: 2,
            drag: this.results.length >= 2
          },
          1024: {
            perPage: 3,
            drag: this.results.length >= 3
          },
          1280: {
            perPage: 4,
            drag: this.results.length >= 4
          },
          1536: {
            perPage: 5,
            drag: this.results.length >= 5
          },
        }
      }
    }
  }
}
</script>
